import client from '../../client';
import {
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_FAIL,
  ADD_ROLE_TO_USER,
  ADD_ROLE_TO_USER_SUCCESS,
  ADD_ROLE_TO_USER_FAIL,
  DELETE_USER_ROLE,
  DELETE_USER_ROLE_SUCCESS,
  DELETE_USER_ROLE_FAIL,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_FAIL
} from '../constants/users';

export const getUsers = () => dispatch => {
  dispatch({
    type: GET_USERS
  });
  client
    .get('user')
    .then(({ data }) => {
      dispatch({
        type: GET_USERS_SUCCESS,
        data
      })
    })
    .catch(error => {
      dispatch({
        type: GET_USERS_FAIL,
        error
      })
    })
}

export const addUserRole = (userId, role) => dispatch => {
  dispatch({
    type: ADD_ROLE_TO_USER
  });
  client
    .put(`user/${userId}/roles`, { role })
    .then(({ data }) => {
      dispatch({
        type: ADD_ROLE_TO_USER_SUCCESS,
        data
      })
    })
    .catch(error => {
      dispatch({
        type: ADD_ROLE_TO_USER_FAIL,
        error
      })
    })
}

export const deleteUserRole = (userId, role) => dispatch => {
  dispatch({
    type: DELETE_USER_ROLE
  });

  client
    .delete(`user/${userId}/roles/${role}`)
    .then(({ data }) => {
      dispatch({
        type: DELETE_USER_ROLE_SUCCESS,
        data
      })
    })
    .catch(error => {
      dispatch({
        type: DELETE_USER_ROLE_FAIL,
        error
      })
    })
}

export const logoutUser = userId => dispatch => {
  dispatch({
    type: LOGOUT_USER
  })
  client
    .delete(`user/${userId}/logout`)
    .then(() => dispatch({
      type: LOGOUT_USER_SUCCESS
    }))
    .catch(() => dispatch({
      type: LOGOUT_USER_FAIL
    }))
}



// WEBPACK FOOTER //
// ./src/redux/actions/users.js